/**
 * react-hook-form `validate` rule: refuses values that are empty after
 * trimming, so a name of only spaces isn't saved (QA batch 16, SET-004 /
 * TEAM-008).
 */
export const notBlank =
  (message = "This field is required") =>
  (value?: string | null) =>
    (value ?? "").trim().length > 0 || message;

/** The text with spaces at both ends removed (undefined stays undefined). */
export const trimmed = <T extends string | null | undefined>(value: T): T =>
  (typeof value === "string" ? value.trim() : value) as T;
